 export class AppError{
    constructor(public originalError?:any, public showAlert = true){

    }

}